var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChooseIcon02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 34,
    viewBox: "0 0 36 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 0.5H3C1.34315 0.5 0 1.84315 0 3.5V23C0 24.6569 1.34315 26 3 26H33C34.6569 26 36 24.6569 36 23V3.5C36 1.84315 34.6569 0.5 33 0.5Z",
    fill: "#E6F9FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 20V0.5C2.20464 0.500943 1.44213 0.817316 0.879721 1.37972C0.317316 1.94213 0.000942812 2.70464 0 3.5L0 23C0.000942812 23.7954 0.317316 24.5579 0.879721 25.1203C1.44213 25.6827 2.20464 25.9991 3 26H33C33.7954 25.9991 34.5579 25.6827 35.1203 25.1203C35.6827 24.5579 35.9991 23.7954 36 23H6C5.20464 22.9991 4.44213 22.6827 3.87972 22.1203C3.31732 21.5579 3.00094 20.7954 3 20Z",
    fill: "#CCF2FE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.5H36V12.5H0V6.5Z",
    fill: "url(#paint0_linear_118_153)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6843 24.8107L22.8053 22.6897L31.054 30.9384L28.933 33.0594L20.6843 24.8107Z",
    fill: "#01C0F9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15 26C19.9706 26 24 21.9706 24 17C24 12.0294 19.9706 8 15 8C10.0294 8 6 12.0294 6 17C6 21.9706 10.0294 26 15 26Z",
    fill: "#E6F9FE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15 27.5C12.9233 27.5 10.8932 26.8842 9.16652 25.7304C7.4398 24.5767 6.09399 22.9368 5.29927 21.0182C4.50455 19.0996 4.29661 16.9884 4.70176 14.9516C5.1069 12.9148 6.10693 11.0438 7.57538 9.57538C9.04384 8.10693 10.9148 7.1069 12.9516 6.70176C14.9884 6.29661 17.0996 6.50455 19.0182 7.29927C20.9368 8.09399 22.5767 9.4398 23.7304 11.1665C24.8842 12.8932 25.5 14.9233 25.5 17C25.4969 19.7838 24.3896 22.4527 22.4212 24.4212C20.4527 26.3896 17.7838 27.4969 15 27.5ZM15 9.50001C13.5166 9.50001 12.0666 9.93987 10.8332 10.764C9.59986 11.5881 8.63857 12.7594 8.07091 14.1299C7.50325 15.5003 7.35473 17.0083 7.64412 18.4632C7.9335 19.918 8.64781 21.2544 9.6967 22.3033C10.7456 23.3522 12.082 24.0665 13.5368 24.3559C14.9917 24.6453 16.4997 24.4968 17.8701 23.9291C19.2406 23.3614 20.4119 22.4002 21.236 21.1668C22.0601 19.9334 22.5 18.4834 22.5 17C22.4978 15.0116 21.7069 13.1052 20.3008 11.6992C18.8948 10.2931 16.9884 9.50224 15 9.50001Z",
    fill: "#99E6FD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15 18.5C15.8284 18.5 16.5 17.8284 16.5 17C16.5 16.1716 15.8284 15.5 15 15.5C14.1716 15.5 13.5 16.1716 13.5 17C13.5 17.8284 14.1716 18.5 15 18.5Z",
    fill: "#34CDFA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 18.5C20.3284 18.5 21 17.8284 21 17C21 16.1716 20.3284 15.5 19.5 15.5C18.6716 15.5 18 16.1716 18 17C18 17.8284 18.6716 18.5 19.5 18.5Z",
    fill: "#34CDFA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 18.5C11.3284 18.5 12 17.8284 12 17C12 16.1716 11.3284 15.5 10.5 15.5C9.67157 15.5 9 16.1716 9 17C9 17.8284 9.67157 18.5 10.5 18.5Z",
    fill: "#34CDFA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_118_153",
    x1: 7.5,
    y1: 20,
    x2: 28.5,
    y2: -0.999999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34CDFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8D9F1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChooseIcon02);
export default __webpack_public_path__ + "static/media/choose_icon02.96d3d0c8787d5326f8a1d305b7e29b78.svg";
export { ForwardRef as ReactComponent };